import SeriesTamisController from './series.tamis.controller';

export default {
    template: require('./series.tamis.tpl.html'),
    controller: SeriesTamisController
};
